import { Outlet } from "react-router-dom";

import {
  Bookmarks,
  BubbleChart,
  CompareArrows,
  Domain,
  Person,
  QueryStats,
  RocketLaunch,
  UploadFile,
} from "@mui/icons-material";

import { AppContainer, AuthContainer } from "@/components/containers";
import { DialogRoot } from "@/components/molecules";
import {
  ActivationProvider,
  AudienceProvider,
  CompareProvider,
  SnackbarProvider,
  DialogProvider,
  ViewModeProvider,
} from "@/context";
import { Navigation } from "@/types";

const NAVIGATION: Navigation = [
  {
    segment: "audience",
    title: "Audiences",
    icon: <Person />,
    pattern: "audience/:id?/:segment?",
  },
  {
    segment: "upload",
    title: "Upload",
    icon: <UploadFile />,
    pattern: "upload/:id?/:segment?",
    hidden: true,
  },
  {
    segment: "mindset",
    title: "Mindsets",
    icon: <BubbleChart />,
    pattern: "mindset/:id?/:segment?",
    hidden: true,
  },
  {
    segment: "library",
    title: "Audience Library",
    icon: <Bookmarks />,
    pattern: "library/:id?/:segment?",
  },
  {
    segment: "activation",
    title: "Activation",
    icon: <RocketLaunch />,
    pattern: "activation/:id?/:segment?",
    hidden: true,
  },
  {
    segment: "compare",
    title: "Compare",
    icon: <CompareArrows />,
    pattern: "compare/:audienceIds?",
    hidden: true,
  },
  {
    segment: "site",
    title: "Sites",
    icon: <Domain />,
    pattern: "site/:id?/:segment?",
    hidden: true,
  },
  {
    segment: "measurement",
    title: "Measurement",
    icon: <QueryStats />,
    hidden: true,
  },
  // {
  //   segment: 'explore',
  //   title: 'Explore',
  //   icon: <Explore />,
  // },
];

function App() {
  return (
    <AuthContainer>
      <SnackbarProvider>
        <DialogProvider>
          <ViewModeProvider>
            <AudienceProvider>
              <CompareProvider>
                <ActivationProvider>
                  <AppContainer navigation={NAVIGATION}>
                    <Outlet />
                    <DialogRoot />
                  </AppContainer>
                </ActivationProvider>
              </CompareProvider>
            </AudienceProvider>
          </ViewModeProvider>
        </DialogProvider>
      </SnackbarProvider>
    </AuthContainer>
  );
}

export default App;
